import { TeaBlocksError } from './../../TeaBlocksError';
import { ReturnBlock } from '../ReturnBlock';
import { VoidBlock } from '../VoidBlock';

/**
 * Block for creating/modifying a variable. Assigns a value to some variable name in variable environment.
 */
export class VarAssignBlock extends VoidBlock {
    varName: string;
    value: ReturnBlock;

    /**
     * Constructor (doesn't create the variable itself tho)
     * 
     * @param varName variable name
     * @param value value being assigned to the variable (only uses value[0])
     */
    constructor(id: string, varName: string, value: ReturnBlock[]) {
        super(id)
        this.varName = varName;
        this.value = value[0];
    }

    /**
     * Evaluates the variable assignment
     * @param varEnv the variable envornment
     */
    *evalBlock(varEnv: Map<string, any>) {
        if (this.varName.includes('$') || this.varName.includes('&')) {
            throw new TeaBlocksError('Variable name contains illegal character', this.id);
        }
        let evalValue = this.value.evalBlock(varEnv);
        varEnv.set(this.varName, evalValue);
        yield;
    }
}
